import Header from '../components/Header'
import Footer from '../components/Footer'
import { ArrowLeft, Play, Clock } from 'lucide-react'
import { VIDEOS } from '../config/assets'

// 使用OSS视频
const InstallationVideo = VIDEOS.AIR_HEATER_INSTALL
const CleaningVideo = VIDEOS.AIR_HEATER_CLEAN
const ExhaustFanVideo = VIDEOS.AIR_HEATER_REPAIR

const videos = [
  {
    id: 1,
    title: '风暖炉安装教程',
    description: '详细介绍风暖炉的安装步骤和注意事项',
    video: InstallationVideo,
    duration: '15:30',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20installation%20tutorial&image_size=landscape_4_3'
  },
  {
    id: 2,
    title: '风暖炉清灰教程',
    description: '教您如何正确清理风暖炉，保持设备高效运行',
    video: CleaningVideo,
    duration: '10:20',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20cleaning%20tutorial&image_size=landscape_4_3'
  },
  {
    id: 3,
    title: '风暖炉更换排烟风机视频',
    description: '详细讲解风暖炉排烟风机的更换步骤和注意事项',
    video: ExhaustFanVideo,
    duration: '9:15',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20exhaust%20fan%20replacement&image_size=landscape_4_3'
  },
  {
    id: 4,
    title: '风暖炉常见故障排查',
    description: '常见故障的识别和解决方法',
    video: '',
    duration: '8:45',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20troubleshooting&image_size=landscape_4_3'
  },
  {
    id: 5,
    title: '风暖炉日常维护',
    description: '日常维护保养的重要性和方法',
    video: '',
    duration: '7:15',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20maintenance&image_size=landscape_4_3'
  },
  {
    id: 6,
    title: '风暖炉安全操作',
    description: '安全使用风暖炉的注意事项',
    video: '',
    duration: '6:30',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20safety%20operation&image_size=landscape_4_3'
  },
  {
    id: 7,
    title: '风暖炉故障维修',
    description: '常见故障的维修方法和步骤',
    video: '',
    duration: '12:45',
    thumbnail: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=biomass%20heater%20repair&image_size=landscape_4_3'
  }
]

export default function AirHeaterMaintenanceVideosPage() {
  return (
    <div className="min-h-screen bg-secondary-50">
      <Header />
      
      {/* 页面标题区 */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <a href="/resources" className="w-6 h-6 cursor-pointer hover:text-primary-100 transition-colors">
              <ArrowLeft className="w-6 h-6" />
            </a>
            <h1 className="text-3xl md:text-4xl font-bold">风暖炉维修视频教程</h1>
          </div>
          <p className="text-primary-100 text-lg ml-10 mt-2">专业的风暖炉安装、维护、故障维修视频教程</p>
        </div>
      </div>

      {/* 视频网格 */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {videos.map((video) => (
              <div key={video.id} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-secondary-100">
                {/* 视频/播放器区域 - 竖屏模式 */}
                <div className="relative aspect-[9/16] overflow-hidden bg-black">
                  {/* 1. 本地视频：有进度条 */}
                  {video.video ? (
                    <video
                      src={video.video}
                      poster={video.thumbnail}
                      className="w-full h-full object-cover"
                      controls
                      preload="metadata"
                    />
                  ) : (
                    // 2. 外部视频链接：使用封面图和链接
                    <a 
                      href="#" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block w-full h-full"
                    >
                      <div className="relative w-full h-full bg-secondary-100">
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                          <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                            <Play className="w-8 h-8 text-white" />
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>

                {/* 视频信息 */}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-secondary-500 mb-2">
                    <Clock className="w-4 h-4" />
                    <span>{video.duration}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-secondary-900 mb-2 line-clamp-2">
                    {video.title}
                  </h3>
                  <p className="text-secondary-600 line-clamp-2">{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 维护保养要点 */}
      <section className="py-16 bg-secondary-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-secondary-900 text-center mb-12">维护保养要点</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary-900 mb-2">定期清理</h3>
              <p className="text-secondary-600">每月清理一次燃烧室和烟道，确保设备正常运行</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary-900 mb-2">检查配件</h3>
              <p className="text-secondary-600">定期检查风机、电机等配件，及时更换磨损部件</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-secondary-900 mb-2">安全操作</h3>
              <p className="text-secondary-600">操作前确保电源关闭，使用专业工具进行维修</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}